// ./src/graph/graphprops/AlertsEvolutionProps.ts
import { ChartConfiguration, ChartDataSets } from "chart.js";
import { Interval } from "../../navigation/tabs/TabsTypes";
import xAxeTimeDefaultProps from "./XAxeTimeDefaultProps";
import { getDateRange } from "./helpers/minmaxDates";
import { sortDatasetsByMaxValue } from "./helpers/sortDatasetsByMaxValue";

export const graphProps = (
  dates: Date[],
  interval: Interval,
  startDateTimestamp: number,
  endDateTimestamp: number,
  datasets: ChartDataSets[]
): ChartConfiguration => {
  const { minDate, maxDate } = getDateRange(dates);

  const sortedDatasets = sortDatasetsByMaxValue(datasets);
  
  const props: ChartConfiguration = {
    type: "bar",
    data: { datasets: sortedDatasets }, // Use sorted datasets here
    options: {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: "Évolution des Alarmes", // Adjust this to your dynamic title needs
        fontSize: 18,
        fontColor: '#333',
        fontStyle: 'bold',
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          fontColor: '#333',
          fontSize: 12,
          usePointStyle: true,
          padding: 15,
        },
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 15,
          bottom: 15,
        },
      },
      scales: {
        xAxes: [
          xAxeTimeDefaultProps(
            minDate,
            maxDate,
            interval,
            startDateTimestamp,
            endDateTimestamp,
            true,
            true
          ),
        ],
        yAxes: [
          {
            gridLines: {
              color: '#e0e0e0',
              zeroLineColor: '#e0e0e0',
              borderDash: [2, 2],
            },
            ticks: {
              min: 0,
              suggestedMax: undefined,
              fontColor: '#333',
            },
            stacked: false,
          },
        ],
      },
      tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        backgroundColor: '#004aac',
        titleFontColor: '#fff',
        bodyFontColor: '#fff',
        footerFontColor: '#fff',
      },
    },
  };
  return props;
};
